module.exports = __webpack_public_path__ + "img/fotoRecicladorDefault.e0e5a28b.png";